  <template>
  <div class="riven-layout" >
    <div class="riven-layout-right" :class="{ 'taiwan-layout': isTaiwan, 'japan-layout': isJapan }">
      <div v-if="!isJapan" class="riven-layout-header"  :class="{ 'taiwan-layout-header': isTaiwan }">
        <slot name="header">
          <div class="riven-layout-header-custom">
            <slot name="header-custom"/>
          </div>
          <div class="riven-layout-header-right">
            <slot name="header-right"/>
          </div>
        </slot>
      </div>
      <div class="riven-layout-container" :class="{ 'japan-riven-layout-container': isJapan }">
        <slot />
      </div>
    </div>

    <div class="riven-layout-left" v-if="!isTaiwanOrJapan" >
      <Sidebar v-bind="$attrs" />
    </div>
  </div>
</template>

<script>
import Sidebar from './sidebar';

export default {
  props: {},
  components: {
    Sidebar,
  },
  inheritAttrs: false,
  computed: {
    isTaiwan() {
      return window.location.host.includes('okki.com');
    },
    isJapan() {
      return window.location.host.includes('okki.ai')
    },
    isTaiwanOrJapan() {
      return window.location.host.includes('okki.com') || window.location.host.includes('okki.ai')
    },
  },
};
</script>

<style lang="scss">
$headerHeight: 66px;
$sideBarWidth: 64px;
$sideBarOpenedWidth: 250px;

.riven-layout {
  min-height: 100vh;
}

.riven-layout-left {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 31;
}

.riven-layout-right {
  box-sizing: border-box;
  padding: 0 0 0 #{$sideBarOpenedWidth};
  transition: padding-left 0.3s;

  @at-root .is-menu-collapsed & {
    padding: 0 0 0 #{$sideBarWidth};
  }
}

.taiwan-layout.riven-layout-right {
  padding-left: 0;
}
.japan-layout.riven-layout-right {
  padding-left: 0;
}
.riven-layout-header.taiwan-layout-header {
  padding-left: 0;
}

.riven-layout-header {
  width: 100%;
  height: 66px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.27);
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 0 0 #{$sideBarOpenedWidth};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  box-sizing: border-box;
  transition: padding-left 0.3s;

  @at-root .is-menu-collapsed & {
    padding: 0 0 0 #{$sideBarWidth};
  }

  .riven-layout-header-custom {
    padding: 0 0 0 60px;
    flex: 1;
  }
}

.riven-layout-container {
  width: 100%;
  display: flex;
  padding: #{$headerHeight} 0 0 0;
}
.japan-riven-layout-container {
  padding-top: 0;
}
</style>
